module.exports = __webpack_public_path__ + "static/savaari_logo-c24fb445e7181d567570892ea28e7663.png";